import { Card, CardDescription, CardHeader, CardTitle } from "@bcc/components/ui/card";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@bcc/components/ui/dialog";
import { PlusCircle, ShoppingBag } from "lucide-react";
import { useTranslation } from "react-i18next";
import { setAddProductSelectionModalTestId } from "./add-product-selection-modal.utils";

interface AddProductSelectionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectManual: () => void;
  onSelectShopify: () => void;
  testId?: string;
}

export function AddProductSelectionModal({ open, onOpenChange, onSelectManual, onSelectShopify, testId }: AddProductSelectionModalProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent testId={testId ?? setAddProductSelectionModalTestId("content")} className="sm:max-w-[720px]">
        <DialogHeader>
          <DialogTitle>{t("views.addProductModal.title")}</DialogTitle>
          <DialogDescription>{t("views.addProductModal.description")}</DialogDescription>
        </DialogHeader>

        <div className="grid gap-4 py-4">
          <Card className="cursor-pointer transition-all hover:border-primary hover:shadow-md" onClick={onSelectManual}>
            <CardHeader>
              <div className="flex items-start gap-4">
                <div className="rounded-lg bg-primary/10 p-3">
                  <PlusCircle className="h-6 w-6 text-primary" />
                </div>
                <div className="flex-1">
                  <CardTitle className="text-lg">{t("views.addProductModal.manual.title")}</CardTitle>
                  <CardDescription className="mt-2">{t("views.addProductModal.manual.description")}</CardDescription>
                  <ul className="mt-3 space-y-1 text-sm text-muted-foreground">
                    <li>• {t("views.addProductModal.manual.benefit1")}</li>
                    <li>• {t("views.addProductModal.manual.benefit2")}</li>
                    <li>• {t("views.addProductModal.manual.benefit3")}</li>
                  </ul>
                </div>
              </div>
            </CardHeader>
          </Card>

          <Card className="cursor-pointer transition-all hover:border-primary hover:shadow-md" onClick={onSelectShopify}>
            <CardHeader>
              <div className="flex items-start gap-4">
                <div className="rounded-lg bg-green-500/10 p-3">
                  <ShoppingBag className="h-6 w-6 text-green-600" />
                </div>
                <div className="flex-1">
                  <CardTitle className="text-lg">{t("views.addProductModal.shopify.title")}</CardTitle>
                  <CardDescription className="mt-2">{t("views.addProductModal.shopify.description")}</CardDescription>
                  <ul className="mt-3 space-y-1 text-sm text-muted-foreground">
                    <li>• {t("views.addProductModal.shopify.benefit1")}</li>
                    <li>• {t("views.addProductModal.shopify.benefit2")}</li>
                    <li>• {t("views.addProductModal.shopify.benefit3")}</li>
                  </ul>
                </div>
              </div>
            </CardHeader>
          </Card>
        </div>
      </DialogContent>
    </Dialog>
  );
}
